import styled from 'styled-components';

import { contentColorMap } from '../../contentColor';
import { fontWeightMap } from '../../fontWeight';
import commonHeadingStyles, { HeadingProps } from '../common/styles';

const H1 = styled.h1.withConfig({
	shouldForwardProp: (prop) => prop !== 'contentColor' && prop !== 'fontWeight',
})<HeadingProps>`
	${commonHeadingStyles};
	font-weight: ${({ fontWeight }) => (fontWeight ? fontWeightMap[fontWeight] : 'normal')};
	color: ${({ theme, contentColor }) => (contentColor ? contentColorMap[contentColor](theme) : theme.colors.dark)};
	font-size: 3rem;
	line-height: 133%;
`;

export default H1;
